import { styled } from "@mui/material";

export default function DescriptionProductCard({ children }) {
	const StyledComponent = styled("div")(({ theme }) => ({
		fontFamily: "Sen",
		fontSize: "0.75rem",
		zIndex: 10,
		color: "rgba(255 255 255 / 80%)",
		[theme.breakpoints.down("sm")]: {
			fontSize: "0.55rem",
		},
	}));

	return <StyledComponent>{children}</StyledComponent>;
}
